import {addAuthToAxiosOpts} from '../config/queryopts'
import {useQueryWithAuthentication} from "./index";
import {apiUrlInternal} from "../config/api"
import axios from "axios";


export const OrganizationsIntelSearchFetcher = (uid, accessToken) => {
  return axios.get(`${apiUrlInternal}/organizations/${uid}/ticket_coins`, addAuthToAxiosOpts(accessToken, {})).then(res => res.data);
}


export const useOrganizationsTicketCoinsQuery = (uid, fetcher = OrganizationsIntelSearchFetcher) => {
  return useQueryWithAuthentication(
    ['organizations-ticket-coins', uid], (accessToken) => fetcher(uid, accessToken)
  )
}
